import React from 'react';

class CategoryList extends React.Component {

	render() {
		const defaultCssClass = 'categories__list';
		let cssClass = this.props.cssClass ? defaultCssClass + ' ' + this.props.cssClass : defaultCssClass;

		let categories = this.props.categories;

		return (
			
			<ul className={cssClass}>
				{categories.map((category, index) =>
					<li className="list__item item--shop-category" key={index}>
						<a href={category.url}>{category.name}</a>
					</li>
				)}				
			</ul>

		);
	}
}	

export default CategoryList;